import React from 'react';

const ThemeSevenBanner = props => {
  return (
    <div className="themes-theme-seven-banner ">
      {props.topBanner ? (
        <div className="new-container top-banner">
          <a href="https://turismozaahj.co.cl/" target="_blank">
            <img src="/assets/fernandez/home/BF_banner_calafate_torres.png" alt="" />
          </a>
        </div>
      ) : null}

      {props.bottomBanner ? (
        <div className="bottom-banner ">
          <div className="details new-container">
            <div>
              <h2 className="bold-text">
                <span>Descubre Magallanes</span>
              </h2>
              <p>
                Te invitamos a descubrir el extremo sur del mundo, la región de Magallanes y la
                Antártica Chilena. La llamada Patagonia Austral, es un territorio mágico donde cada
                rincón esconde increíbles sorpresas. Lugares distantes y remotos, donde aprendes a
                escuchar el silencio y sentir la naturaleza en toda su magnitud. Deslúmbrate con la
                magia del Macizo Paine y los Campos de Hielo del Sur, siente la majestuosidad de las
                montañas o navega por los canales patagónicos, hasta llegar a las rutas marítimas
                del Estrecho de Magallanes.
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );

  //
};

export default ThemeSevenBanner;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/common/ThemeSevenBanner.js